export default __webpack_public_path__ + "static/media/bell.b445fc56.svg";